import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import RequestsCardItems from './RequestsCardItems';

const RequestsCards = ({
  canCreate,
  category,
  handleScroll,
  items,
  itemsPerRow,
  newRequestCode,
  onCheckBoxClick,
  readErrors,
  readStatus,
  review,
  single,
}) => (
  <InfiniteScrollCards
    canCreate={canCreate}
    className="aridhia-request-cards"
    entity={review ? 'review' : 'request'}
    handleScroll={handleScroll}
    icon="key"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={readErrors}
    readStatus={[readStatus]}
    url={codeUrl(urls.REQUEST, newRequestCode, '#')}
  >
    <RequestsCardItems
      category={category}
      items={items}
      onCheckBoxClick={onCheckBoxClick}
      review={review}
      single={single}
    />
  </InfiniteScrollCards>
);

export default RequestsCards;
